import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import "./ReportTemplate.scss";

/** Lazily Loaded Components */
const ReportTemplateList = lazy(() =>import("./components/reportTemplateList/ReportTemplateList"));
const AddEditReportTemplate = lazy(() =>import("./components/addEditReportTemplate/AddReportTemplate"));
const EditReportTemplate = lazy(() =>import("./components/editReportTemplate/EditReportTemplate"));

const ReportTemplate = () => {
  const molGridRef = useRef();
  const [isEdit, setIsEdit] = useState(false);
  const [editReportTemplateData, seteditReportTemplateData] = useState(null);
  const [isReportTemplateModelOpen, setIsReportTemplateModelOpen] =useState(false);
  const [isReportTemplateDetailsModelOpen,setIsReportTemplateDetailsModelOpen] = useState(false);

  const handleAddReportTemplateClick = () => {
    setIsReportTemplateModelOpen(true);
    seteditReportTemplateData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsReportTemplateModelOpen(false);
    setIsReportTemplateDetailsModelOpen(false);
    seteditReportTemplateData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    seteditReportTemplateData(data);
    setIsReportTemplateDetailsModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="report-templates-sec">
        <CardSection
          cardTitle={"Reporting Templates"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddReportTemplateClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
            <ReportTemplateList ref={molGridRef} onEdit={handleEditClick} />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={`Add Report Template`}
        modalSize={"w-50"}
        isOpen={isReportTemplateModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditReportTemplate
          isEdit={isEdit}
          isOpen={isReportTemplateModelOpen}
          initData={editReportTemplateData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>

      <CenterModal
        modalTitle={`Update Report Template`}
        modalSize={"w-60"}
        isOpen={isReportTemplateDetailsModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <div className="edit-report-template-sec">
          <EditReportTemplate
            isEdit={isEdit}
            isOpen={isReportTemplateModelOpen}
            initData={editReportTemplateData}
            onClose={handleCloseModel}
            onSuccess={handleSuccess}
          />
        </div>
      </CenterModal>
    </>
  );
};

export default ReportTemplate;
